<template>
    <div>
        <reset-check-time :uuids="uuids" :servicestatus="servicestatus" @command="command">
        </reset-check-time>
        <maintenance :uuids="uuids" :downtime="downtime" :servicestatus="servicestatus" @command="command">
        </maintenance>
        <acknowledge v-if="servicestatus.currentState > 0" :uuids="uuids" :ids="ids" :servicestatus="servicestatus" :acknowledgement="acknowledgement"
                     @command="command">
        </acknowledge>
        <passive-check :uuids="uuids" :servicestatus="servicestatus" @command="command">
        </passive-check>
        <flap :uuids="uuids" :servicestatus="servicestatus" @command="command">
        </flap>
        <notifications :uuids="uuids" :servicestatus="servicestatus" @command="command">
        </notifications>
        <custom-notification :uuids="uuids" :servicestatus="servicestatus" @command="command">
        </custom-notification>
    </div>
</template>

<script>
import Maintenance from "./ServiceMaintenance";
import ResetCheckTime from "./ServiceResetCheckTime";
import Acknowledge from "./ServiceAcknowledge";
import PassiveCheck from "./ServicePassiveCheck";
import Flap from "./ServiceFlap";
import Notifications from "./ServiceNotifications";
import CustomNotification from "./ServiceCustomNotification";
import {useToast} from "vue-toastification";

export default {
    name: "Actions",
    components: {Maintenance, ResetCheckTime, Acknowledge, PassiveCheck, Flap, Notifications, CustomNotification},
    props: [
        'uuids',
        'ids',
        'servicestatus',
        'downtime',
        'acknowledgement'
    ],
    methods: {
      /*  refresh(){
            this.$emit('refresh-event');
        },*/
        command(payload, type){

            if(type === 'submit') {
                axios.post('/services/externalCommands.json', payload)
                    .then(response => {
                        useToast().success(this.$t('Command successfully sent'), {
                            timeout: 7000
                        });
                        setTimeout(() => {
                            this.$emit('refresh-event');
                        }, 7000);
                    }).catch(error => {
                        useToast().error(this.$t('error'), {
                            timeout: 2000
                        });
                    })
                    .finally(() => {
                    });
            }
            if(type === 'deleteAck') {
                axios.post('/services/deleteAcknowledgements.json', payload)
                    .then(response => {
                        useToast().success(this.$t('Command successfully sent'), {
                            timeout: 7000
                        });
                        setTimeout(() => {
                            this.$emit('refresh-event');
                        }, 7000);
                    }).catch(error => {
                        useToast().error(this.$t('error'), {
                            timeout: 2000
                        });
                    })
                    .finally(() => {
                    });
            }
            if(type === 'deleteDowntime') {
                axios.post('/downtimes/delete.json', payload)
                    .then(response => {
                        useToast().success(this.$t('Command successfully sent'), {
                            timeout: 8000
                        });
                        setTimeout(() => {
                            this.$emit('refresh-event');
                        }, 8000);
                    }).catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                })
                    .finally(() => {
                    });

            }
        },
    }
}
</script>

<style scoped>

</style>
